import { render, staticRenderFns } from "./Subforum.vue?vue&type=template&id=488140a7&"
import script from "./Subforum.vue?vue&type=script&lang=js&"
export * from "./Subforum.vue?vue&type=script&lang=js&"
import style0 from "./Subforum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports